import { useState } from "react";
import { useScreenSize } from "hooks";
import { DropDown } from "components/atoms";
import { MOBILE_WIDTH } from "utils/constants";
import { Typography } from "components/atoms/Typography";
import { TestScoreByTests } from "../TestScoreByTests";
import { Tab } from "../Tab";
import { PerformanceByTestsTable } from "../Table/PerformanceByTests/PerformanceByTestsTable";
import { PerformanceByTopic } from "../PerformanceByTopic";
import "./index.scss";
import {
  useGetPerformanceByTestQuery,
  useGetTestScoresAndPerformanceQuery,
} from "services/homeApi";

interface IProps {
  isMobile?: boolean;
  isTab?: boolean;
  theme:"light"|"dark";
}

export const PrepInformation = ({ isMobile, isTab,theme }: IProps) => {
  const [selectedItem, setselectedItem] = useState<
    null | string | { [key: number]: string }
  >("Test Scores");
  const { data, isLoading, isError } = useGetPerformanceByTestQuery();
  const {
    isLoading: isTestScoresLoading,
    isError: isTestScoresError,
    data: testScoresData,
  } = useGetTestScoresAndPerformanceQuery();

  // const isTestScoresLoading = false;
  // const isTestScoresError = false;

  const screen = useScreenSize();
  return (
    <>
      {screen.width > MOBILE_WIDTH ? (
        <div className="prepinfo-tab-section">
          <div className="score-title-section">
            <Typography label="Test Scores and Performance" variant="h3Bold"/>
          </div>
          <Tab
            tabTitles={[
              <Typography variant="h7Med" label="Test Scores" />,
              <Typography variant="h7Med" label="Performance By Tests" />,
              <Typography variant="h7Med" label="Performance By Topic" />,
            ]}
            tabContents={[
              <PerformanceByTestsTable
                isTab={isTab}
                isLoading={isTestScoresLoading}
                isError={isTestScoresError}
                data={testScoresData}
                theme={theme}
              />,
              <TestScoreByTests
                isTab={isTab}
                data={data}
                isLoading={isLoading}
                isError={isError}
                theme={theme}
              />,
              <PerformanceByTopic isTab={isTab} theme={theme}/>,
            ]}
          />
        </div>
      ) : (
        <div className="prep-informationn-mobile-wrapper">
          <Typography
            styles="test-score-header-text"
            variant="h4Bold"
            label="Test Scores & Performance"
          />
          <div className="drop-down-wrapper">
            <DropDown
              setDropDownSelection={setselectedItem}
              data={[
                "Test Scores",
                "Performance By Tests",
                "Performance By Topic",
              ]}
              defaultSelected={selectedItem}
            />
          </div>
          <div className="performance-horizontal-bar-section">
            {selectedItem &&
            Object.values(selectedItem)[0] === "Test Scores" ? (
              <PerformanceByTestsTable
                isMobile={isMobile}
                isLoading={isTestScoresLoading}
                isError={isTestScoresError}
                data={testScoresData}
                theme={theme}
              />
            ) : selectedItem &&
              Object.values(selectedItem)[0] === "Performance By Tests" ? (
              <TestScoreByTests
                isMobile={isMobile}
                data={data}
                isLoading={isLoading}
                isError={isError}
                theme={theme}
              />
            ) : (
              <PerformanceByTopic isMobile={isMobile} isTab={isTab} theme={theme}/>
            )}
          </div>
        </div>
      )}
    </>
  );
};
